import React from "react";

const Footer: React.FC = () => {

    return (
        <div style={{textAlign: 'center', padding: '1rem', fontSize:'0.8rem', color:'#585858'}}>
            <div>Albemarle VMS ©{new Date().getFullYear()}</div>
            <div>v1.3.27.20250709</div>
        </div>
    )
}

export default Footer;